// dependencies
import React from "react";

import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// styles
import css from "./QueryButton.module.scss";

interface BaseProps {
	text: string;
	onClick?: (value: any) => void;
	isStatic?: boolean;
	type?: string;
	disabled?: boolean;
	color?: "blue" | "green" | "red";
}

const QueryButton = (props: BaseProps) => {
	const { text, onClick = () => {}, isStatic = false, type = "", disabled = false, color = "blue" } = props;

	const iconLookup = {
		add: faPlus,
	};
	return (
		<div className={`${disabled ? css.disabled : ""}`}>
			<button
				className={`${isStatic ? css.staticButton : css.createButton} ${!isStatic ? css[color] : null}`}
				onClick={(e) => onClick(e)}
				disabled={disabled}
			>
				{!isStatic && type ? (
					<div className={css.buttonIcon}>
						{" "}
						<FontAwesomeIcon icon={iconLookup[type]} />{" "}
					</div>
				) : null}
				<div>{text}</div>
			</button>
		</div>
	);
};

export default QueryButton;
